import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import MKTypography from "components/MKTypography";
import { Link } from "react-router-dom";

function ExistingKnowledgeDocumentCard({ knowledgeDocument }) {
  return (
    <Card
      component={Link}
      to={`/admin/agents/knowledge-document?knowledgeDocumentId=${knowledgeDocument.id}`}
      sx={{
        "&:hover": {
          transform: "scale(1.02)",
          transition: "transform 0.3s ease-in-out",
          boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        },
        height: "100%",
        minHeight: "300px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography variant="h5" gutterBottom>
          {knowledgeDocument.subject}
        </Typography>

        <MKTypography
          variant="body2"
          color="text"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 10, // Limit to 6 lines
            WebkitBoxOrient: "vertical",
            flex: 1,
          }}
        >
          {knowledgeDocument.summary}
        </MKTypography>
      </CardContent>
    </Card>
  );
}

ExistingKnowledgeDocumentCard.propTypes = {
  knowledgeDocument: PropTypes.object.isRequired,
};

export default ExistingKnowledgeDocumentCard;
